__turbopack_context__.v({
  "close-button": "ToastItem-module-scss-module__8a034q__close-button",
  "fade-in": "ToastItem-module-scss-module__8a034q__fade-in",
  "fade-out": "ToastItem-module-scss-module__8a034q__fade-out",
  "slide-in": "ToastItem-module-scss-module__8a034q__slide-in",
  "toast": "ToastItem-module-scss-module__8a034q__toast",
});
